import { render, staticRenderFns } from "./CopyTableToClipboard.vue?vue&type=template&id=09024a88"
import script from "./CopyTableToClipboard.vue?vue&type=script&lang=js"
export * from "./CopyTableToClipboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports